import { render, staticRenderFns } from "./AnzcorSearchResults.vue?vue&type=template&id=ec13ce26&"
import script from "./AnzcorSearchResults.vue?vue&type=script&lang=js&"
export * from "./AnzcorSearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports